export default __webpack_public_path__ + "static/media/autonomia.9ac7e876.svg";